
    <cradua-seismic-community
    [lgas]="lgas$ | async"
  [seismiccommunitys]="seismiccommunitys$ | async"

  (changeEmit)="onSubmitSeismicCommunity($event)"
  (deleteEvent)="onDeleteSeismicCommunity($event)"

  *ngIf="
  !(isLoadingLga$ | async ) &&
  !(isLoadingSeismicCommunity$ | async )
  "
  >
    >
  </cradua-seismic-community>
  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingLga$ | async ) ||
  (isLoadingSeismicCommunity$ | async )
  "
>
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
 
